import script from "./AppTab.vue?vue&type=script&lang=ts"
export * from "./AppTab.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__